



































































import Vue from "vue";
import Toolbar from "../components/toolbar/Toolbar.vue";
import storeHelper from "../store/store-helper";
import Utils from "@/utils";
import SubscriptionsList from "../components/modules/subscriptions/SubscriptionsList.vue";
import SubscriptionsFilter from "../components/modules/subscriptions/SubscriptionsFilter.vue";
import { SubscriptionFilterGroup } from "../types/subscriptions/subscriptionFilterGroup";
import { Subscription, SourceMini, MailFrequency } from "@infoland/iprova-api";

export default Vue.extend({
    name: "Subscriptions",
    components: { Toolbar, SubscriptionsList, SubscriptionsFilter },
    data: () => {
        return {
            searchText: "",
            loadedSubscriptionsBySearchText: [] as Subscription[],
            loadedSubscriptions: [] as Subscription[],
            selectedModules: [] as SubscriptionFilterGroup[],
            selectedCurrentSubscriptionGroups: [] as SubscriptionFilterGroup[],
            modules: [] as SourceMini[],
            currentSubscriptionGroups: [] as SubscriptionFilterGroup[],
            subscriptionsFilterDrawer: false,
            subscriptionsLoaded: false
        };
    },
    async created() {
        let subscriptions: Subscription[];
        if (storeHelper.subscriptionsStore.subscriptions) {
            subscriptions = storeHelper.subscriptionsStore.subscriptions;
        } else {
            subscriptions = await storeHelper.subscriptionsStore.loadMySubscriptionsAsync();
        }

        this.loadedSubscriptions = this.getOrderedSubscriptions(subscriptions);
        this.loadedSubscriptionsBySearchText = this.getOrderedSubscriptions(subscriptions);
        document.title = Utils.getPageTitle(`${this.$t("settings.subscriptions.mySubscriptions")}`, "before");
        for (let subscription of subscriptions) {
            if (this.modules.findIndex(x => x.id === subscription.source_mini.id && x.name === subscription.source_mini.name) == -1) {
                this.modules.push({ id: subscription.source_mini.id, name: subscription.source_mini.name });
            }
        }
        this.subscriptionsLoaded = true;

        this.currentSubscriptionGroups = [
            {
                id: 1,
                name: `${this.$t("settings.subscriptions.showInMessageList")}`
            },
            {
                id: 2,
                name: `${this.$t("settings.subscriptions.email")}`
            }
        ];
    },
    computed: {
        mdAndDownView(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        haveSubscriptions(): boolean {
            return this.loadedSubscriptions.length === 0;
        }
    },
    watch: {
        async searchText(newValue: string) {
            await this.doSearch(newValue);
        },
        selectedModules() {
            this.filterByGroups();
        },
        selectedCurrentSubscriptionGroups() {
            this.filterByGroups();
        }
    },
    methods: {
        async doSearch(searchText: string): Promise<void> {
            let subscriptions = storeHelper.subscriptionsStore.subscriptions;
            if (searchText) {
                subscriptions = subscriptions.filter(subscription => {
                    return (
                        subscription.name.toLowerCase().includes(searchText.toLowerCase()) ||
                        subscription.source_mini.name.toLowerCase().includes(searchText.toLowerCase())
                    );
                });
            }
            this.loadedSubscriptionsBySearchText = this.getOrderedSubscriptions(subscriptions);
            this.filterByGroups();
        },
        subscriptionsComparer(firstSubscription: Subscription, secondSubscription: Subscription) {
            if (firstSubscription.source_mini.name === secondSubscription.source_mini.name) {
                return firstSubscription.name > secondSubscription.name ? 1 : -1;
            }
            return firstSubscription.source_mini.name > secondSubscription.source_mini.name ? 1 : -1;
        },
        filterByGroups(): void {
            let subscriptions = this.loadedSubscriptionsBySearchText;
            if (this.selectedModules.length > 0) {
                subscriptions = subscriptions.filter(
                    s => this.selectedModules.findIndex(x => x.id === s.source_mini.id && x.name === s.source_mini.name) != -1
                );
            }
            if (this.selectedCurrentSubscriptionGroups.length > 0) {
                subscriptions = subscriptions.filter(
                    s =>
                        (this.selectedCurrentSubscriptionGroups.length === 2 &&
                            s.show_in_messages_list &&
                            s.mail_frequency !== (typeof s.mail_frequency === "string" ? MailFrequency[MailFrequency.never] : MailFrequency.never)) ||
                        (this.selectedCurrentSubscriptionGroups.length === 1 &&
                            ((this.selectedCurrentSubscriptionGroups.find(x => x.id == 1) && s.show_in_messages_list) ||
                                (this.selectedCurrentSubscriptionGroups.find(x => x.id == 2) &&
                                    s.mail_frequency !==
                                        (typeof s.mail_frequency === "string" ? MailFrequency[MailFrequency.never] : MailFrequency.never))))
                );
            }
            this.loadedSubscriptions = subscriptions;
        },
        getOrderedSubscriptions(subscriptions: Subscription[]) {
            return subscriptions.sort(this.subscriptionsComparer);
        },
        goBack() {
            this.$router.push({ name: "Settings" });
        },
        removeFilter(): void {
            this.searchText = "";
            this.selectedModules = [];
            this.selectedCurrentSubscriptionGroups = [];
        }
    }
});
